import { Box, RadioGroup } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import useGetAccountData from 'features/account/ui/common/useGetAccountData'
import EntireOrganizationOption from './EntireOrganizationOption'
import WithGroupsOption from './WithGroupOption'
import { Typography } from '@carto/meridian-ds/components'
import { ShareWithGroups } from '../ShareOptionShared/ui/ShareWithGroups'
import { CommonSharingScope } from 'features/common/types'
import { Group } from 'features/groups'

function SharedWithOrganizationMode({
  mode = 'organization',
  groups,
  onChangeMode,
  onChangeGroups,
  disabled,
  sharingScope,
  readonly
}: {
  mode: string
  groups: Group[]
  onChangeMode: (newMode: string) => void
  onChangeGroups: (newGroups: Group[]) => void
  disabled?: boolean
  sharingScope?: CommonSharingScope
  readonly?: boolean
}) {
  const accountData = useGetAccountData()
  const hasEnterpriseSso = accountData.quotas?.enterpriseSsoAvailable
  const isShareWithGroupsEnabled = hasEnterpriseSso
  const newMode = sharingScope ? (sharingScope === CommonSharingScope.Organization ? 'organization' : 'groups') : mode
  return (
    <Box>
      <Typography variant="caption" fontWeight="medium">
        <FormattedMessage id={'common.shareDialog.sharingMode.title'} />
      </Typography>
      <RadioGroup aria-label="mode" name="mode" value={newMode} onChange={(_, mode) => onChangeMode(mode)}>
        <Box display="flex">
          <EntireOrganizationOption disabled={disabled} />
          <WithGroupsOption disabled={disabled || !isShareWithGroupsEnabled} />
        </Box>
      </RadioGroup>
      {(mode === 'groups' || sharingScope === CommonSharingScope.Specific) && (
        <ShareWithGroups
          disabled={disabled}
          selectedGroups={groups}
          isShareWithGroupsEnabled={isShareWithGroupsEnabled}
          onSelectedGroupsChange={onChangeGroups}
          readonly={readonly}
        />
      )}
    </Box>
  )
}

export default SharedWithOrganizationMode
